import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Center,
  Flex,
  SimpleGrid,
  Spinner,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import MapCarrosFiliais from "./MapCarrosFiliais";
import { useState } from "react";
import AddCarrosFiliais from "./AddCarrosFiliais";
import { getFirestoreApp } from "../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronRightIcon } from "@chakra-ui/icons";

const FeedFilias = () => {
  const navigate = useNavigate();
  const [carros, SetCarros] = useState([]);
  const [loading, setLoading] = useState(true);
  const { filialId } = useParams();

  useEffect(() => {
    filialId;
  }, [filialId]);

  const db = getFirestoreApp;
  const ListCarrosDocument = collection(
    db,
    "/FILIAIS/91IYpjJbXYN99Asq2Enw/",
    filialId
  );

  const getCarros = async () => {
    const data = await getDocs(ListCarrosDocument);
    SetCarros(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
    // console.log(
    //   "getCarros function is called and data is: ",
    //   data.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    // );
    setLoading(false);
  };

  useEffect(() => {
    setTimeout(() => {
      getCarros();
    }, 150);
  }, []);

  return (
    <>
      <Flex
        justifyContent={"center"}
        alignItems="center"
        width={"full"}
        height={"100%"}
        gap={2}
      >
        <Flex
          width={"150%"}
          height="full"
          // borderColor="gray.300"
          // borderRadius={"md"}
          p="2"
          flexDirection={"column"}
          justifyContent={"center"}
          gap={5}
        >
          <Breadcrumb separator={<ChevronRightIcon color="gray.500" />}>
            <BreadcrumbItem>
              <BreadcrumbLink onClick={() => navigate(`/`)}>
                Filiail
              </BreadcrumbLink>
            </BreadcrumbItem>

            <BreadcrumbItem isCurrentPage>
              <BreadcrumbLink>{filialId}</BreadcrumbLink>
            </BreadcrumbItem>
          </Breadcrumb>

          <AddCarrosFiliais getCarros={getCarros} />

          {loading === true ? (
            <Flex justifyContent="center" mt="15%">
              <Spinner
                thickness="8px"
                speed="0.65s"
                emptyColor="gray.200"
                color="blue.500"
                width={100}
                height={100}
              />
            </Flex>
          ) : carros.length > 0 ? (
            <SimpleGrid
              spacing={5}
              templateColumns="repeat(auto-fill, minmax(300px, 1fr))"
            >
              {carros.map((carro) => (
                <MapCarrosFiliais
                  key={carro.id}
                  carro={carro}
                  getCarros={getCarros}
                />
              ))}
            </SimpleGrid>
          ) : (
            <Alert
              status="info"
              variant="top-accent"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              textAlign="center"
              height="200px"
              borderRadius={10}
            >
              <AlertIcon boxSize="40px" mr={0} />
              <AlertTitle mt={4} mb={1} fontSize="lg">
                Nenhum carro cadastradado na filial {filialId}
              </AlertTitle>
              <AlertDescription maxWidth="sm">
                Verifique se o nome está correto, caso sim, clique em Adcionar
                Veículo.
              </AlertDescription>
            </Alert>
          )}
        </Flex>
      </Flex>
    </>
  );
};

export default FeedFilias;
